import { render, staticRenderFns } from "./UltimasNoticias.vue?vue&type=template&id=66f62020"
import script from "./UltimasNoticias.vue?vue&type=script&lang=js"
export * from "./UltimasNoticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports